import React, { Component, Fragment } from 'react';
import { Navbar, Container, Row, Col, Nav } from 'react-bootstrap';
import Logo from '../../assets/images/chrisalpha.png';
import { Link } from "react-router-dom";
import MegaMenuAll from '../home/MegaMenuAll';
import { FaChevronDown } from "react-icons/fa";
import Swal from 'sweetalert2';

class NavMenuDesktop extends Component {


  handleJobClick = (e) => {

    if (!localStorage.getItem("token")) {

        e.preventDefault();

        Swal.fire({
            icon: 'warning',
            title: 'Login Required',
            text: 'Please login first to access job applications.',
            confirmButtonText: 'Login'
        }).then(() => {

            window.location.href = '/login';

        });

    }

}
  constructor() {
    super();

    this.state = {
      SideNavState: "sideNavClose",
      ContentOverState: "ContentOverlayClose",
      showServices: false,
      showAbout: false,
      showProducts: false,
      showDemo: false,

      // Social links
      facebook_link: "https://www.facebook.com/ChrisAlphaTechCompany/",
      youtube_link: "https://www.youtube.com/@ChrisAlphaTechCompany",
      instagram_link: "https://www.instagram.com/chrisalphatechcompany/",
      linkedin_link: "https://www.linkedin.com/in/chrisalpha-tech-company-limited-4179b12b1",
      tiktok_link: "https://www.tiktok.com/@chris.alpha.tech",
      whatsapp_link: "https://wa.me/256784226089"
    };
  }

  MenuBarClickHandler = () => this.SideNavOpenClose();
  ContentOverlayClickHandler = () => this.SideNavOpenClose();

  SideNavOpenClose = () => {
    if (this.state.SideNavState === "sideNavOpen") {
      this.setState({
        SideNavState: "sideNavClose",
        ContentOverState: "ContentOverlayClose"
      });
    } else {
      this.setState({
        SideNavState: "sideNavOpen",
        ContentOverState: "ContentOverlayOpen"
      });
    }
  };
  logout = () => {
  localStorage.clear();
  window.location.href = "/login";
};

  render() {

    let buttons;

    if (localStorage.getItem('token')) {


      buttons = (
        <div className="d-flex align-items-center gap-2">

          <Link to="/notification" className="btn">
            <i className="fa h4 fa-bell"></i>
            <sup>
              <span className="badge text-white bg-danger">5</span>
            </sup>
          </Link>

         <Link to="/dashboard" className="btn btn-outline-primary btn-sm">
  DASHBOARD
</Link>

<Link to="/profile" className="btn btn-outline-success btn-sm">
  PROFILE
</Link>

      <Link to="/" onClick={this.logout} className="h4 btn">
  LOGOUT
</Link>

          

        </div>
      );

    } else {

      buttons = (
        <div className="d-flex align-items-center gap-2">

         

          <Link to="/notification" className="btn">
            <i className="fa h4 fa-bell"></i>
            <sup>
              <span className="badge text-white bg-danger">5</span>
            </sup>
          </Link>

          <Link to="/login" className="btn btn-outline-primary btn-sm">
            LOGIN
          </Link>

          <Link to="/register" className="btn btn-primary btn-sm">
            REGISTER
          </Link>

          

        </div>
      );
    }

    return (
      <Fragment>

        <div className="TopSectionDown">

          {/* TOP RIBBON */}

          <div className="top-ribbon">
            <Container fluid>

              <Row className="align-items-center">

                <Col lg={6} md={6} sm={12} className="text-start">
                  <span className="ribbon-text">📞 +256 784226089</span>
                  <span className="ribbon-divider">|</span>
                  <span className="ribbon-text">
                    📧 sales@chrisalphatech.com
                  </span>
                </Col>

                <Col lg={6} md={6} sm={12} className="text-end">

                  <div className="social-icons">

                    <a
                      href={this.state.facebook_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook m-1 h4"></i>
                    </a>

                    <a
                      href={this.state.youtube_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube m-1 h4"></i>
                    </a>

                    <a
                      href={this.state.instagram_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram m-1 h4"></i>
                    </a>

                    <a
                      href={this.state.linkedin_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin m-1 h4"></i>
                    </a>

                    <a
                      href={this.state.tiktok_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-tiktok m-1 h4"></i>
                    </a>

                    <a
                      href={this.state.whatsapp_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab m-1 h4 fa-whatsapp"></i>
                    </a>

                  </div>

                </Col>

              </Row>

            </Container>
          </div>

          {/* NAVBAR */}

          <Navbar fixed="top" bg="light">

            <Container fluid className="main-navbar shadow-sm p-2 mb-0 bg-white">

              <Row className="w-100 align-items-center">

                {/* LOGO */}

                <Col lg={2} md={2} className="d-flex align-items-center">

                  <Link to="/">
                    <img
                      className="nav-logo"
                      src={Logo}
                      alt="logo"
                    />
                  </Link>

                </Col>

                {/* MENU */}

                <Col lg={8} md={7}>

                  <Nav className="d-flex justify-content-center flex-nowrap">

                    <Nav.Item>
                      <Link to="/" className="service-item">
                        Home
                      </Link>
                    </Nav.Item>

                    {/* ABOUT */}

                    <Nav.Item>
                      <Link to="/about" className="service-item">
                        About Us
                      </Link>
                    </Nav.Item>

                    {/* PRODUCTS */}

                    <Nav.Item
                      className="position-relative"
                      onMouseEnter={() => this.setState({ showProducts: true })}
                      onMouseLeave={() => this.setState({ showProducts: false })}
                    >

                      <button className="nav-link btn btn-link d-flex align-items-center">

                        Our Products

                        <FaChevronDown
                          className="ms-2"
                          style={{
                            transition: "0.3s",
                            transform: this.state.showProducts
                              ? "rotate(180deg)"
                              : "rotate(0deg)"
                          }}
                        />

                      </button>

                      <div className={`services-dropdown ${this.state.showProducts ? "show" : ""}`}>

                        <Link to="/parkease" className="service-item">Parkease</Link>
                        <Link to="/pospresso" className="service-item">Pospresso</Link>
                        <Link to="/pospresso_plus" className="service-item">Pospresso-Plus</Link>
                        <Link to="/cat_homis" className="service-item">CAT HOMIS</Link>
                        <Link to="/tradehub" className="service-item">Trade Hub</Link>

                      </div>

                    </Nav.Item>

                    {/* SERVICES */}

                    <Nav.Item
                      className="position-relative"
                      onMouseEnter={() => this.setState({ showServices: true })}
                      onMouseLeave={() => this.setState({ showServices: false })}
                    >

                      <button className="nav-link btn btn-link d-flex align-items-center">

                        Service

                        <FaChevronDown
                          className="ms-2"
                          style={{
                            transition: "0.3s",
                            transform: this.state.showServices
                              ? "rotate(180deg)"
                              : "rotate(0deg)"
                          }}
                        />

                      </button>

                      <div className={`services-dropdown ${this.state.showServices ? "show" : ""}`}>

                        <Link to="/website-development" className="service-item">
                          Website Development
                        </Link>

                        <Link to="/domainhosting" className="service-item">
                          Domain Name & Hosting
                        </Link>

                        <Link to="/cctvcameras" className="service-item">
                          CCTV Cameras
                        </Link>

                        <Link to="/computerrepair" className="service-item">
                          Computer Repair & Maintenance
                        </Link>

                        <Link to="/networking" className="service-item">
                          Computer Networking
                        </Link>

                      </div>

                    </Nav.Item>

                    {/* LIVE DEMO */}

                    <Nav.Item
                      className="position-relative"
                      onMouseEnter={() => this.setState({ showDemo: true })}
                      onMouseLeave={() => this.setState({ showDemo: false })}
                    >

                      <button className="nav-link btn btn-link d-flex align-items-center">

                        Live Demo

                        <FaChevronDown
                          className="ms-2"
                          style={{
                            transition: "0.3s",
                            transform: this.state.showDemo
                              ? "rotate(180deg)"
                              : "rotate(0deg)"
                          }}
                        />

                      </button>

                      <div className={`services-dropdown ${this.state.showDemo ? "show" : ""}`}>

                        <Link to="/parking" className="service-item">
                          Parkease
                        </Link>

                        <Link to="/pospressolive" className="service-item">
                          Pospresso
                        </Link>

                        <Link to="/PospressoPlusLive" className="service-item">
                          Pospresso-Plus
                        </Link>

                        <Link to="/cathomisLive" className="service-item">
                          CAT HOMIS
                        </Link>

                        <Link to="/tradehublive" className="service-item">
                          Trade Hub
                        </Link>

                      </div>

                    </Nav.Item>

                    <Nav.Item>
                      <Link to="/contact" className="service-item">
                        Contact Us
                      </Link>
                    </Nav.Item>
          <Nav.Item>
    <Link
        to="/jobs"
        className="service-item"
        onClick={this.handleJobClick}
    >
        Jobs
    </Link>
</Nav.Item>

                  </Nav>

                </Col>

                {/* RIGHT SIDE */}

                <Col
                  lg={2}
                  md={3}
                  className="d-flex justify-content-end align-items-center gap-2"
                >

                  {buttons}

                  <Link
                    to="/requestquote"
                    className="btn btn-primary btn-sm"
                  >
                    Request for Quote
                  </Link>

                </Col>

              </Row>

            </Container>

          </Navbar>

        </div>

        {/* SIDE MENU */}

        <div className={this.state.SideNavState}>
          <MegaMenuAll />
        </div>

        <div
          onClick={this.ContentOverlayClickHandler}
          className={this.state.ContentOverState}
        />

      </Fragment>
    );
  }
}

export default NavMenuDesktop;